module.exports = __webpack_public_path__ + "_resource/logo.2a5d7.png";